import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm mt-8" }
const _hoisted_2 = { class: "px-6" }
const _hoisted_3 = { class: "grid gap-6" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_5 = { class: "grid gap-6 md:grid-cols-2" }
const _hoisted_6 = ["aria-invalid"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["value"]
const _hoisted_11 = ["aria-invalid"]
const _hoisted_12 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_13 = ["aria-invalid"]
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_15 = ["aria-invalid"]
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_18 = { class: "md:col-span-2" }
const _hoisted_19 = ["aria-invalid"]
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = ["aria-invalid"]
const _hoisted_23 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_24 = { class: "flex justify-between items-center px-6 pt-6" }

import { computed, ref } from 'vue'
import { useCompanyRegistrationStore } from '@/stores/companyRegistrationStore'
import type { CompanyIndustryOption, CompanyIndustrySubcategory } from '@/types/company'

import LogoUploader from './LogoUploader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyDetailsStep',
  props: {
    draftId: {},
    industries: {},
    companyIndustryOptions: {}
  },
  emits: ['update', 'next', 'back'],
  setup(__props: any, { emit: __emit }) {

const store = useCompanyRegistrationStore()

const props = __props

const emits = __emit

// const localData = ref({ ...props.data })
const errors = ref<Record<string, string>>({})

const selectedIndustryName = computed(() => {
  const raw = store.form.industry
  if (raw == null || raw === '') return ''

  const asNumber = Number(raw)
  if (!Number.isNaN(asNumber)) {
    const match = props.industries.find((industry) => industry.id === asNumber)
    if (match?.name) return match.name
  }

  return String(raw).trim()
})

const selectedCompanyIndustryOption = computed<CompanyIndustryOption | null>(() => {
  const normalized = selectedIndustryName.value.trim().toLowerCase()
  if (!normalized) return null

  return props.companyIndustryOptions.find((option) => {
    const name = option.name.trim().toLowerCase()
    const slug = option.slug.trim().toLowerCase()
    return normalized === name || normalized === slug || normalized.includes(name) || name.includes(normalized)
  }) ?? null
})

const subcategoryOptions = computed<CompanyIndustrySubcategory[]>(() =>
  selectedCompanyIndustryOption.value?.subcategories ?? []
)

const handleIndustryChange = () => {
  const selected = subcategoryOptions.value.find(
    (subcategory) => subcategory.id === Number(store.form.industrySubcategoryId)
  )
  if (!selected) {
    store.form.industrySubcategoryId = null
    store.form.industrySubcategory = ''
  }
}

const handleSubcategoryChange = () => {
  const selected = subcategoryOptions.value.find(
    (subcategory) => subcategory.id === Number(store.form.industrySubcategoryId)
  )
  store.form.industrySubcategory = selected?.name ?? ''
  if (!selected) {
    store.form.industrySubcategoryId = null
  }
}

const INDUSTRIES = [
  'Mining & Resources',
  'Oil & Gas',
  'Construction',
  'Manufacturing',
  'Technology',
  'Healthcare',
  'Finance',
  'Other',
]

const EMPLOYEE_SIZES = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '5001-10000',
  '10000+',
]

// watch(localData, (val) => emits('update', val), { deep: true })

// Validation now uses store.form directly
const validateAndProceed = () => {
  const f = store.form
  const newErrors: Record<string, string> = {}

  if (!f.companyName.trim()) newErrors.companyName = 'Company name is required'
  if (!f.industry) newErrors.industry = 'Please select an industry'
  if (!f.website.trim()) newErrors.website = 'Website is required'
  else if (!/^https?:\/\/.+/.test(f.website)) newErrors.website = 'Please enter a valid URL (e.g., https://example.com)'
  if (!f.headOffice.trim()) newErrors.headOffice = 'Head office location is required'
  if (!f.employeeSize) newErrors.employeeSize = 'Please select employee size'
  if (f.contactEmail.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.contactEmail)) {
    newErrors.contactEmail = 'Please enter a valid email address'
  } else if (f.contactEmail.trim().length > 255) {
    newErrors.contactEmail = 'Company email must be 255 characters or fewer'
  }
  if (!f.companySummary.trim()) newErrors.companySummary = 'Company summary is required'

  errors.value = newErrors
  if (Object.keys(newErrors).length === 0) emits('next')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 pb-4" }, [
      _createElementVNode("div", { class: "leading-none font-semibold text-lg" }, "Company Details"),
      _createElementVNode("div", { class: "text-muted-foreground text-sm" }, " Tell us about your company and what you do ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LogoUploader, {
          onError: _cache[0] || (_cache[0] = (msg) => errors.value.companyLogo = msg)
        }),
        (_unref(store).logoError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(store).logoError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Industry", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).form.industry) = $event)),
              onChange: handleIndustryChange,
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.value.industry
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "Select industry", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.industries, (industry) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: industry.id,
                  value: String(industry.id)
                }, _toDisplayString(industry.name), 9, _hoisted_7))
              }), 128))
            ], 40, _hoisted_6), [
              [_vModelSelect, _unref(store).form.industry]
            ]),
            (errors.value.industry)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value.industry), 1))
              : _createCommentVNode("", true)
          ]),
          (subcategoryOptions.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, [
                  _createTextVNode("Subcategory "),
                  _createElementVNode("span", { class: "text-muted-foreground" }, "(optional)")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).form.industrySubcategoryId) = $event)),
                  class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
                  onChange: handleSubcategoryChange
                }, [
                  _cache[11] || (_cache[11] = _createElementVNode("option", { value: null }, "Select subcategory", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategoryOptions.value, (subcategory) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: subcategory.id,
                      value: subcategory.id
                    }, _toDisplayString(subcategory.name), 9, _hoisted_10))
                  }), 128))
                ], 544), [
                  [
                    _vModelSelect,
                    _unref(store).form.industrySubcategoryId,
                    void 0,
                    { number: true }
                  ]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Website", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(store).form.website) = $event)),
              type: "url",
              placeholder: "https://example.com",
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.value.website
            }, null, 8, _hoisted_11), [
              [_vModelText, _unref(store).form.website]
            ]),
            (errors.value.website)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.website), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Head Office", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(store).form.headOffice) = $event)),
              type: "text",
              placeholder: "Perth, Western Australia",
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.value.headOffice
            }, null, 8, _hoisted_13), [
              [_vModelText, _unref(store).form.headOffice]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-muted-foreground mt-1" }, "Primary office location", -1)),
            (errors.value.headOffice)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errors.value.headOffice), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Employee Size", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(store).form.employeeSize) = $event)),
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.value.employeeSize
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "Select size", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(EMPLOYEE_SIZES, (size) => {
                return _createElementVNode("option", {
                  key: size,
                  value: size
                }, _toDisplayString(size), 9, _hoisted_16)
              }), 64))
            ], 8, _hoisted_15), [
              [_vModelSelect, _unref(store).form.employeeSize]
            ]),
            (errors.value.employeeSize)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value.employeeSize), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, [
              _createTextVNode("Company email "),
              _createElementVNode("span", { class: "text-muted-foreground" }, "(optional)")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(store).form.contactEmail) = $event)),
              type: "email",
              placeholder: "contact@example.com",
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.value.contactEmail
            }, null, 8, _hoisted_19), [
              [_vModelText, _unref(store).form.contactEmail]
            ]),
            (errors.value.contactEmail)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errors.value.contactEmail), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Company Summary", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(store).form.companySummary) = $event)),
              placeholder: "Describe your company's mission, operations, and key activities...",
              class: "w-full min-h-32 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
              "aria-invalid": !!errors.value.companySummary
            }, null, 8, _hoisted_22), [
              [_vModelText, _unref(store).form.companySummary]
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-muted-foreground mt-1" }, " A brief overview of your company (2–3 sentences) ", -1)),
            (errors.value.companySummary)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(errors.value.companySummary), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md border border-border text-sm hover:bg-muted",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('back')))
      }, " Back "),
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md bg-brand text-white text-sm hover:opacity-90",
        onClick: validateAndProceed
      }, " Next ")
    ])
  ]))
}
}

})